import { render, staticRenderFns } from "./OrderFinalDeliveryHead.vue?vue&type=template&id=1dd9067e&scoped=true&"
import script from "./OrderFinalDeliveryHead.vue?vue&type=script&lang=js&"
export * from "./OrderFinalDeliveryHead.vue?vue&type=script&lang=js&"
import style0 from "./OrderFinalDeliveryHead.vue?vue&type=style&index=0&id=1dd9067e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd9067e",
  null
  
)

export default component.exports